import styles from './MultiPanelCell.module.scss';

import cx from 'classnames';
import React, { HTMLAttributes, forwardRef } from 'react';

import type { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'components/ContentImage/ContentImage';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';
import { TextV2 } from 'components/TextV2/TextV2';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { MULTI_PANEL_CELL_TEST_ID } from './MultiPanelCell.const';

interface IMultiPanelCellProps extends HTMLAttributes<HTMLDivElement> {
  entry?: FlatEntry<Subject>;
}

export const MultiPanelCell = forwardRef<HTMLDivElement, IMultiPanelCellProps>(
  ({ entry, className }, ref) => {
    if (!entry) return null;
    const { title, titleColor, blurb, link, image, backgroundColor, richBlurb } = entry;

    return (
      <div
        data-testid={MULTI_PANEL_CELL_TEST_ID.cell}
        ref={ref}
        className={cx(className, styles.gridCell)}
        style={{ backgroundColor }}
      >
        {image && (
          <ContentLinkV2 entry={link} hideTitle>
            <ContentImage entry={image} className={styles.image} />
          </ContentLinkV2>
        )}
        <div className={styles.content}>
          <TextV2
            hasId
            isMarkdown
            value={title}
            entry={{ ...entry, field: 'title' }}
            tagName="h2"
            variant="h4"
            className={styles.title}
            style={{ color: titleColor }}
          />
          <TextV2
            isMarkdown
            value={blurb}
            entry={{ ...entry, field: 'blurb' }}
            tagName="div"
            variant="body"
            className={styles.blurb}
          />
          <RichBlurb document={richBlurb} className={styles.blurb} />
          <ContentLinkV2 entry={link} variant="body" className={styles.learnMore} />
        </div>
      </div>
    );
  },
);

MultiPanelCell.displayName = 'MultiPanelCell';
